
import {formatNumbers, roundValue} from '@/helpers/format';
import {isArray} from "@/helpers/check_variable_types";

export default {
    data() {
        return {

        }
    },
    methods: {
        prepareDataForDateComparison: function(data, columns, dateRange)
        {
            let tableData = {
                columns: [],
                subColumns: {},
                rows: []
            };
            let headers = [];

            let dateRangeA = dateRange.startDate.clone().format("YYYY-MM-DD") + ',' + dateRange.endDate.clone().format("YYYY-MM-DD");
            let dateRangeB = dateRange.startDateB.clone().format("YYYY-MM-DD") + ',' + dateRange.endDateB.clone().format("YYYY-MM-DD");

            for (let column of columns)
            {
                if (column.visible)
                {
                    tableData.columns.push(column);
                }

                if (tableData.subColumns[column.field] == undefined)
                {
                    tableData.subColumns[column.field] = null;
                }

                if (column.isDateComparisonComparableColumn)
                {
                    let compareSubHeader = [];

                    let dateRangeAFormatted = dateRange.startDate.clone().format("DD/MM/YYYY") + ' - ' + dateRange.endDate.clone().format("DD/MM/YYYY");
                    let dateRangeBFormatted = dateRange.startDateB.clone().format("DD/MM/YYYY") + ' - ' + dateRange.endDateB.clone().format("DD/MM/YYYY");

                    compareSubHeader.push(dateRangeAFormatted);
                    compareSubHeader.push(dateRangeBFormatted);
                    compareSubHeader.push('Change');
                    compareSubHeader.push('Change (%)');

                    tableData.subColumns[column.field] = compareSubHeader;
                }
            }

            for (let row of data)
            {
                let rowItem = {};

                for (let column of columns)
                {
                    rowItem.cursor = row.cursor;

                    if (column.visible)
                    {
                        if (column.isDateComparisonComparableColumn)
                        {
                            if (column.isMetricValue)
                            {
                                if (isArray(row.node.metrics) && row.node.metrics.length > 1)
                                {
                                    if (rowItem[column.field] == undefined)
                                    {
                                        rowItem[column.field] = [];
                                    }

                                    let metricsData = row.node.metrics;

                                    let indexDateRangeA = metricsData.findIndex(function(item){
                                        return item.dateRange == dateRangeA;
                                    });

                                    let dateRangeAValue = null;
                                    if (indexDateRangeA != -1)
                                    {
                                        dateRangeAValue = this.format(metricsData[indexDateRangeA][column.field], column.format);
                                    }
                                    rowItem[column.field].push(dateRangeAValue);

                                    let indexDateRangeB = metricsData.findIndex(function(item){
                                        return item.dateRange == dateRangeB;
                                    });

                                    let dateRangeBValue = null;
                                    if (indexDateRangeB != -1)
                                    {
                                        dateRangeBValue = this.format(metricsData[indexDateRangeB][column.field], column.format);
                                    }
                                    rowItem[column.field].push(dateRangeBValue);

                                    rowItem[column.field].push(this.format(dateRangeBValue - dateRangeAValue, {type: 'float', precision: '2'}));
                                    rowItem[column.field].push(this.format(((dateRangeBValue - dateRangeAValue) / dateRangeBValue) * 100, {type: 'percentage', precision: '2'}));
                                }
                                else
                                {
                                    if (rowItem[column.field] == undefined)
                                    {
                                        rowItem[column.field] = [];
                                    }

                                    rowItem[column.field].push(this.format(row.node.metrics[0][column.field], column.format));
                                    rowItem[column.field].push('N/A');
                                    rowItem[column.field].push('N/A');
                                    rowItem[column.field].push('N/A');
                                }
                            }
                            else
                            {
                                rowItem[column.field] = this.format(row.node[column.field], column.format);
                            }
                        }
                        else
                        {
                            rowItem[column.field] = this.format(row.node[column.field], column.format);
                        }
                    }
                }

                tableData.rows.push(rowItem);
            }

            return tableData;
        },
        prepareDataForTable: function(data, columns)
        {
            let excludeSiteColumn = false;
            let tableData = {
                columns: [],
                rows: []
            };

            let selectedSites = this.selectedSites;
            if (selectedSites && selectedSites.length == 1)
            {
                excludeSiteColumn = true;
            }

            for (let column of columns)
            {
                if (excludeSiteColumn && column.field == 'siteName')
                {
                    continue;
                }

                if (column.visible)
                {
                    tableData.columns.push(column);
                }
            }

            for (let row of data)
            {
                let rowItem = {};

                rowItem['siteId'] = row.node['siteId'];
                rowItem['sourceId'] = row.node['sourceId'];

                for (let column of columns)
                {
                    rowItem.cursor = row.cursor;

                    if (column.visible)
                    {
                        if (column.isMetricValue)
                        {
                            if (isArray(row.node.metrics) && row.node.metrics.length > 1)
                            {
                                let metricsData = row.node.metrics;
                                for (let index in metricsData)
                                {
                                    if (rowItem[column.field] === undefined)
                                    {
                                        rowItem[column.field] = [];
                                    }

                                    rowItem[column.field].push(this.format(metricsData[index][column.field], column.format));
                                }
                            }
                            else
                            {
                                rowItem[column.field] = this.format(row.node.metrics[0][column.field], column.format);
                            }

                            rowItem['dateRange'] = row.node.metrics[0]['dateRange'];
                        }
                        else
                        {
                            rowItem[column.field] = this.format(row.node[column.field], column.format);
                        }
                    }
                }

                tableData.rows.push(rowItem);
            }

            return tableData;
        },
        format: function(value, columnFormat) {

            if(value === null) {
                return "N/A";
            }

            if (columnFormat === undefined || (value === undefined || value === ''))
            {
                return value;
            }

            if (columnFormat.type == 'integer')
            {
                return formatNumbers(value);
            }
            else if (columnFormat.type == 'float')
            {
                return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
            }
            else if (columnFormat.type == 'percentage')
            {
                if (!isNaN(value))
                {
                    return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
                }
                else
                {
                    return 0;
                }
            }
            else if (columnFormat.type == 'currency')
            {
                return formatNumbers(roundValue(value, columnFormat.precision), columnFormat.precision);
            }
            else
            {
                return value;
            }
        },
        formatCustom: function(value, type, precision = null, symbol = null) {

            if(value === null) {
                return "N/A";
            }

            if (type == 'integer')
            {
                return formatNumbers(value);
            }
            else if (type == 'float')
            {
                return formatNumbers(roundValue(value, precision), precision);
            }
            else if (type == 'percentage')
            {
                return formatNumbers(roundValue(value, precision), precision) + (symbol !== null ? symbol : '');
            }
            else if (type == 'currency')
            {
                return formatNumbers(roundValue(value, precision), precision) + (symbol !== null ? symbol : '');
            }
            else
            {
                return value + (symbol !== null ? symbol : '');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table/tableMixin.js